// extracted by mini-css-extract-plugin
export var dateLabel = "_45-0";
export var dateLabelError = "_45-1";
export var fullWidth = "_45-2";
export var smaller = "_45-3";